import { api } from '../config/api'
import { defaultPageSize } from '../utils/constants'
import { generateFilters } from '../utils/filters'

const baseEndpoint = '/TopicApi'

export const getAllTopics = () => api.get(`${baseEndpoint}/GetAll`)

export const getAllFilteredTopics = (pageNumber, pageSize = defaultPageSize, filters) => {
  const params = generateFilters(pageNumber, pageSize, filters)
  return api.get(`${baseEndpoint}/GetAllFiltered?${params.toString()}`)
}

export const suggestTopic = async (topic) =>
  api.post(`${baseEndpoint}/Suggest`, {}, { params: { topic } })
